import { render, staticRenderFns } from "./product-book-viewing-button.vue?vue&type=template&id=2340dd41&"
import script from "./product-book-viewing-button.vue?vue&type=script&lang=js&"
export * from "./product-book-viewing-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports